import { QueryFactory } from '@lmt/shared-types';
import { sendRefreshTokenRequest } from '@lmt/unicorn-shared/app/api/auth/auth-client';
import {
  convertPermissionsFromServer,
  permissionsAreEqual,
} from '@lmt/unicorn-shared/app/api/auth/token-decoder';
import {
  logOut,
  setAuthData,
} from '@lmt/unicorn-shared/app/features/auth/operations';
import { TokenData } from '@lmt/unicorn-shared/app/features/auth/types';
import { NetworkError } from '@lmt/unicorn-shared/app/helpers/error-handling';

export async function checkAndRefreshPermissions(storedToken: TokenData) {
  try {
    const permissionsFromStoredToken = storedToken.claims.permissions;
    const actualPermissions = convertPermissionsFromServer(
      await QueryFactory.UserClient.getCurrentUserPermissions(),
    );
    if (!permissionsAreEqual(permissionsFromStoredToken, actualPermissions)) {
      //Update token to have actual permissions in it, as server uses permissions from token
      const result = await sendRefreshTokenRequest(storedToken.refreshToken);
      setAuthData(result);
    }
  } catch (e: any) {
    console.log('Error refreshing permissions', e);
    if (e.message === NetworkError) {
      throw e;
    }
    logOut();
  }
}
